import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import { lighten, makeStyles, withStyles } from "@material-ui/core/styles";
// import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TimePicker from "@mui/lab/TimePicker";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { TransitionProps } from "@mui/material/transitions";
import axios from "axios";
import jaLocale from "date-fns/locale/ja";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { API_URL } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import ServerlessDeleteButton from "../utilComponent/ServerlessDeleteButton";
import { useLoadingOverlay } from "../../utilHooks/loadingOverlay";
import './style.css';
import ChooseCheckList from '../utilComponent/ChooseCheckList'
import { useRecoilValue } from 'recoil';
import { createdConstructionNameState } from '../../globalStates/createConstructionName';
import { blackBoardDesign, blackboardInfo, blackboardDataId } from '../../BlackBoardConst';
import { formatDate } from './utils/date';

/* form modules */
import { SubmitHandler, useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const InspectionSchema = yup.object({
  set_ins_worktype: yup
    .string()
    .required("必須項目です。")
    .max(50, "50文字以内で入力して下さい。"),
  set_ins_kind: yup
    .string()
    .required("必須項目です。")
    .max(50, "50文字以内で入力して下さい。"),
  set_Date: yup
    .string()
    .required("必須項目です。")
    .matches(
      /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/,
      "正しい形式で入力してください。"
    ),
  set_Time: yup.string().required("必須項目です。"),
  /* 数値で桁制限をかけることができないため、文字列でバリデーションをかける。*/
  set_ins_spno: yup
    .string()
    .required("必須項目です。")
    .max(50, "50桁以内で入力してください。")
    .matches(/^[0-9]+$/, "半角数値で入力してください。"),
  bleach: yup.array(
    yup.object().shape({
      name: yup
        .string()
        .required("必須項目です。")
        .max(25, "25文字以内で入力してください。"),
      user_name: yup
        .string()
        .required("必須項目です。")
        .email("正しいメールアドレスの形式で入力してください。")
        .max(50, "50文字以内で入力してください。"),
    })
  ),
  set_ins_memo: yup.string().max(300, "300文字以内で入力してください。"),
});

interface Charactor {
  name: string;
  user_name: string;
}
interface InspectionSubmitFormType {
  set_ins_worktype: string /*工種*/;
  set_ins_kind: string /*種別*/;
  set_Date: string /*実施日*/;
  set_Time: string /*実施時間*/;
  set_ins_spno: number /*土木共通番号*/;
  bleach: any /*立会者*/;
  set_ins_memo: string /*備考*/;
}

interface blackboard {
  blackboard_color: string;
  opacity_rate: number;
  font_size: string;
  font_color: string;
  character_alignment: string;
  character_placement: string;
  [key: string]: string | number;
}

let displayBoardDesign = { ...blackBoardDesign };

const data: Charactor[] = [
  {
    name: "",
    user_name: "",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
  },
  paper: {
    width: 350,
    height: 300,
    overflow: "auto",
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/



const BorderLinearProgress = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten("#0000FF", 0.9),
  },
  bar: {
    backgroundColor: "#0000FF",
  },
})(LinearProgress);

/*転送リスト*/

function not(a: any, b: any) {
  return a.filter((value: any) => b.indexOf(value) === -1);
}

function intersection(a: any, b: any) {
  return a.filter((value: any) => b.indexOf(value) !== -1);
}

/*転送リスト*/

const InspectionCreat: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay();

  /*id取得*/
  const { state } = useLocation();
  const conid = (state as any)?.conid;




  /**ローカルストレージからデータを取得 */

  const constructionData = JSON.parse(localStorage.getItem("constructionData") || '{}')

  /**ローカルストレージからデータを取得 */

  /** 工事名と実施会社のデータを入力してそのほかのデータを空にする */
  const inspectBlackBoardInfo = blackboardInfo.map(info => {
    let defaultData;
    switch (info.id) {
      case blackboardDataId.constructionName:
        defaultData = { ...info, data: constructionData.constructionName };
        break;
      case blackboardDataId.date:
        const formatted = formatDate();
        defaultData = { ...info, data: formatted };
        break;
      case blackboardDataId.company:
        defaultData = { ...info, data: constructionData.userName };
        break;
      default:
        defaultData = { ...info, data: '' };
    }
    return defaultData
  })
  /** 工事名と実施会社のデータを入力してそのほかのデータを空にする */

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  /*ダイアログ処理*/

  const [checklistActivation, setChecklistActivation] = useState("0");
  const [checkList, setCheckList] = useState({});
  const [files, setFiles] = useState<File[]>([]);
  const [stateBlackBoardInfo, setStateBlackBoardInfo] = useState(inspectBlackBoardInfo);
  const createdConstructionName: string = useRecoilValue(createdConstructionNameState);

  /*ユーザーAPI*/
  useEffect(() => {
    let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
    const company_id = jsonlist.company.company_id;
    openLoading();
    const fetchCompanyData = async () => {

      try {
        const response = await axios.post(
          API_URL.COMPANY_GET,
          { "company_id": company_id },
          { headers: { Authorization: jsonlist.token.IdToken } },
        )
        const blackboard = response.data.data?.blackboard;
        blackboard !== undefined && displayBlackBoard(blackboard)
      } catch (e) {
        console.error(e);
      }
    }

    const fetchUserList = async () => {
      try {
        const response = await axios.post(
          API_URL.USER_LIST,
          { "company_id": jsonlist.user.company_id },
          { headers: { Authorization: jsonlist.token.IdToken } },
        )
        const users = response.data.data;
        const users_list = []
        for (let i in users) {
          users_list.push({ name: users[i].user_name, mail_address: users[i].user_id })
        }
        setLeft(users_list)
        closeLoading()
      } catch (e) {
        console.error(e);
        closeLoading()
      }
    }

    fetchCompanyData();
    fetchUserList();

  }, []);
  /*ユーザーAPI*/

  /*ダイアログ処理*/
  const [Suopen, setSuOpen] = React.useState(false);
  const handleSuOpen = () => {
    setSuOpen(true);
  };

  const handleSuClose = () => {
    setSuOpen(false);
  };
  /*ダイアログ処理*/

  /*行追加削除*/
  // const [charactor, setCharactor] = useState<Charactor[]>([]);

  /* 黒板デザイン表示関数 */

  const displayBlackBoard = (blackboard: blackboard) => {
    displayBoardDesign.color = blackboard.blackboard_color;
    displayBoardDesign.opacity = blackboard.opacity_rate;
    displayBoardDesign.fontSize = blackboard.font_size;
    displayBoardDesign.fontColor = blackboard.font_color;
    displayBoardDesign.alignment = blackboard.character_alignment;
    displayBoardDesign.placement = blackboard.character_placement;
  }

  /** 黒板デザイン表示関数 */

  /* useForm 設定 */
  const {
    handleSubmit,
    control,
    register,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(InspectionSchema),
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "bleach",
  });

  /*　立会者のデフォルトの値を取得する。 */
  useEffect(() => {
    reset({
      bleach: data,
    });
  }, [reset]);
  /*行追加削除*/

  const classes = useStyles();
  const length = 2;
  const length2 = 4;
  // const [progress, setProgress] = useState(50);
  // const [selectedDate, setSelectedData] = useState<MaterialUiPickersDate>(null);
  const [currency, setCurrency] = React.useState("1");
  const [setInsdate, setInsDate] = React.useState<Date | null>(new Date());
  const [setInstime, setInsTime] = React.useState<Date | null>(new Date());
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrency(event.target.value);
  };

  const [personName, setPersonName] = React.useState<string[]>([]);
  const handleChangeMultiple = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { options } = event.target;
    const value: string[] = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setPersonName(value);
  };

  /*ユーザ検索*/
  const DelCheckSubmit = (e: any) => {
    handleClickOpen();
  };
  /*ユーザー検索*/

  /*転送リスト*/

  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState<any[]>([]);
  const [right, setRight] = React.useState([]);
  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value: any) => () => {
    const currentIndex = (checked as any).indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      (newChecked as any).push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight((right as any).concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const customList = (items: any) => (
    <Paper className={classes.paper}>
      <List dense component="div" role="list">
        {items.map((value: any) => {
          const labelId = `transfer-list-item-${value}-label`;
          return (
            <ListItem
              key={value.id}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={(checked as any).indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.name} />
              <ListItemText id={labelId} primary={value.mail_address} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Paper>
  );

  /*転送リスト*/

  /*送信GET*/
  const [set_ins_worktype, setIns_worktype] = useState<string>("");
  const [set_ins_kind, setIns_kind] = useState<string>("");
  const [set_ins_spno, setIns_spno] = useState<string>("");
  const [set_ins_memo, setIns_memo] = useState<string>("");

  const change_ins_worktype = (e: any) => {
    /** 工種を変更する */
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === blackboardDataId.constructionType ? { ...blackboardInfo, data: e.target.value } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);
    setIns_worktype(e.target.value);
  };
  const change_ins_kind = (e: any) => {
    /** 種別を変更する */
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === blackboardDataId.inspectionKind ? { ...blackboardInfo, data: e.target.value } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);
    setIns_kind(e.target.value);
  };
  const change_ins_spno = (e: any) => {
    /** 土木共通仕様書番号を変更する */
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === blackboardDataId.commonNumber ? { ...blackboardInfo, data: e.target.value } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);
    setIns_spno(e.target.value);
  };
  const change_implementation_date = (newValue: any) => {
    /** 実施日を変更する */

    const formattedDate = formatDate(newValue);
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === blackboardDataId.date ? { ...blackboardInfo, data: formattedDate } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);

    setInsDate(newValue);
  }


  const change_ins_memo = (e: any) => {
    setIns_memo(e.target.value);
  };

  const onSubmit: SubmitHandler<InspectionSubmitFormType> = (data) => {
    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/

    const set_Date = moment(setInsdate);
    const set_Time = moment(setInstime);



    // POST処理
    let jsonlist = JSON.parse(localStorage.getItem("datalist") || "{}");
    console.log("jsonList", jsonlist);

    openLoading();

    axios
      .post(
        API_URL.INSPECTION_CREATE,
        {
          company_id: jsonlist.user.company_id,
          dealer_info_id: jsonlist.user.dealer_info_id,
          construction_id: conid,
          inspection_info_name: "入力した検査名",
          blackboard: "XML形式の文字列が入る",
          inspection_url: "Chimeの検査用URL",
          inspection_date: set_Date.format("YYYY/MM/DD"),
          inspection_time: set_Time.format("HH:mm"),
          inspection_work_type: data.set_ins_worktype,
          inspection_kind: data.set_ins_kind,
          common_number: data.set_ins_spno,
          inspection_status: "0",
          template: "テンプレート",
          checklist_activation: checklistActivation,
          remarks: data.set_ins_memo,
          checklist: checkList,
          witness: data.bleach, // Type [{0: {user_name: "test", email: "test@gmail.com"}}]
          actor: right,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        setSuccess(true);
        setLoading(false);
        handleSuOpen();
        console.log("response", res);

        const filesUploaded: Promise<any> = Promise.all(
          files.map((file: File) => {
            const data = new FormData();
            data.append("upload_file", file);
            data.append("company_id", jsonlist.user.company_id);
            data.append("dealer_info_id", jsonlist.user.company_id);
            data.append("construction_id", conid);
            data.append("inspection_info_id", res.data.data.inspection_id);
            data.append("file_type", "3");
            return axios.post(API_URL.FILE_UPLOAD, data, {
              headers: {
                Authorization: jsonlist.token.IdToken,
                "content-type": "multipart/form-data",
              },
            });
          })
        );

        filesUploaded
          .then((res) => {
            console.log("ファイルアップロード成功 : ", res);
          })
          .catch((error) => {
            console.log("ファイルアップロード失敗 : ", error);
          });
      })
      .catch((error) => {
        setSuccess(true);
        setLoading(false);
        console.log(error);
        console.log("something wrong");
      })
      .finally(() => {
        closeLoading();
      });
  };

  const onChooeCheckSwitch = ({
    checklistActivation,
  }: {
    checklistActivation: string;
  }) => {
    setChecklistActivation(checklistActivation);
  };

  const onChooseCheckSelect = ({ checkItems }: { checkItems: any }) => {
    setCheckList(checkItems);
  };

  const onChangeFile = (e: any) => {
    setFiles((files: File[]) => [...files, ...e.target.files]);
  };

  const onClickDelFile = (index: number) => (e: any) => {
    setFiles((files: File[]) => [...files.filter((f, i) => i !== index)]);
  };

  /* errorsオブジェクトを生成し、submit時のundefiendを避ける。 */
  const bleachErrors = errors.bleach;

  /*送信GET*/
  return (
    <GenericTemplate title="検査新規作成">
      <div>
        <Dialog
          open={Suopen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleSuClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>
            {"登録が完了しました"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              component={Link}
              to={{ pathname: "/Inspectionlist", state: { conid: conid } }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"参加者選択"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {/*転送リスト*/}

              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                className={classes.root}
              >
                <Grid item>{customList(left)}</Grid>
                <Grid item>
                  <Grid container direction="column" alignItems="center">
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleAllRight}
                      disabled={left.length === 0}
                      aria-label="move all right"
                    >
                      ≫
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleCheckedRight}
                      disabled={leftChecked.length === 0}
                      aria-label="move selected right"
                    >
                      &gt;
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleCheckedLeft}
                      disabled={rightChecked.length === 0}
                      aria-label="move selected left"
                    >
                      &lt;
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleAllLeft}
                      disabled={right.length === 0}
                      aria-label="move all left"
                    >
                      ≪
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>{customList(right)}</Grid>
              </Grid>
              {/*転送リスト*/}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ m: 1, position: "relative" }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleClose}
                >
                  選択
                </Button>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ m: 1, position: "relative" }}></Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>

      <Stack spacing={3} margin={2}></Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="textBoxInspection">
          <Table className="tg">
            <tbody>
              <tr>
                <th className="tg-0lax">
                  <TextField
                    // required
                    id="outlined-required"
                    label="工種※"
                    variant="outlined"
                    className="InsText"
                    {...register("set_ins_worktype")}
                    error={"set_ins_worktype" in errors}
                    helperText={errors.set_ins_worktype?.message}
                    onChange={change_ins_worktype}
                  />
                </th>
                <th className="tg tw">
                  <ChooseCheckList
                    onSwitch={onChooeCheckSwitch}
                    onSelect={onChooseCheckSelect}
                    checkList={[]}
                    checklistActivation={checklistActivation}
                  />
                </th>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    // required
                    id="outlined-required"
                    label="種別"
                    variant="outlined"
                    className="InsText"
                    {...register("set_ins_kind")}
                    error={"set_ins_kind" in errors}
                    helperText={errors.set_ins_kind?.message}
                    onChange={change_ins_kind}
                  />
                </td>
                <td className="tg-0lax" rowSpan={length2}>
                  <Box className="kokuban" sx={{ border: '1px solid grey' }}>

                    <Box component='div'
                      style={{ 'opacity': displayBoardDesign.opacity / 100 }}
                      className={`
                    blackboard
                     color-${displayBoardDesign.color}
                     font-color-${displayBoardDesign.fontColor}`}
                      sx={{ width: '98%' }}
                    >
                      <Box
                        component='div'
                        className={
                          `blackboard-body
                           font-size-${displayBoardDesign.fontSize}
                          ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}
                      >
                        {stateBlackBoardInfo.map((value) => {
                          return (
                            <Box
                              key={value.id}
                              component='div'
                              className={`blackboard-row ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                              <Box component='div' className={`${value.left}  ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                                <p className={
                                  `blackboard-header
                                  alignment-${displayBoardDesign.alignment}
                                  placement-${displayBoardDesign.placement}`}>
                                  {value.header}
                                </p>
                              </Box>
                              <Box component='div' className={value.right}>
                                <p className={
                                  `blackboard-data
                                  alignment-${displayBoardDesign.alignment}
                                  placement-${displayBoardDesign.placement}`}>
                                  {value.data}
                                </p>
                              </Box>
                            </Box>
                          )
                        })}
                      </Box>
                    </Box>
                  </Box>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={jaLocale}
                  >
                    <DatePicker
                      label="実施日"
                      inputFormat="yyyy/MM/dd"
                      value={setInsdate}
                      // onChange={(newValue) => {
                      //   setInsDate(newValue);
                      // }}

                      onChange={(newValue) => change_implementation_date(newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          {...register("set_Date")}
                          error={"set_Date" in errors}
                          helperText={errors.set_Date?.message}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TimePicker
                      label="実施時間"
                      value={setInstime}
                      onChange={(newValue) => {
                        setInsTime(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          id="time"
                          label="実施時間"
                          type="time"
                          className={classes.textField}
                          defaultValue="07:30"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            step: 300, // 5 min
                          }}
                          {...register("set_Time")}
                          error={"set_Time" in errors}
                          helperText={errors.set_Time?.message}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    id="outlined-basic"
                    label="土木共通仕様書番号※"
                    variant="outlined"
                    className="InsText"
                    // required
                    {...register("set_ins_spno")}
                    error={"set_ins_spno" in errors}
                    helperText={errors.set_ins_spno?.message}
                    onChange={change_ins_spno}
                    style={{ width: 490 }}
                  />
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <FormControl sx={{ m: 0, minWidth: 320, maxWidth: 300 }}>
                    <InputLabel shrink htmlFor="select-multiple-native">
                      参加者
                    </InputLabel>
                    <Select
                      multiple
                      native
                      value={personName}
                      // @ts-ignore Typings are not considering `native`
                      onChange={handleChangeMultiple}
                      label="Native"
                      inputProps={{
                        id: "select-multiple-native",
                      }}
                    >
                      {right.map((name: any) => (
                        <option key={name.id} value={name}>
                          {name.name + " " + name.mail_address}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <Button
                    style={{ color: "#fff", backgroundColor: "#FFA500" }}
                    variant="contained"
                    size="small"
                    onClick={DelCheckSubmit}
                  >
                    検索
                  </Button>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    onClick={() => append({})}
                  >
                    ＋立会者追加
                  </Button>
                  <Stack spacing={3} margin={1}></Stack>
                  <div className="textBoxWit">
                    <section>
                      <table>
                        <tbody>
                          {fields.map((field, index) => (
                            <tr>
                              <td style={{ width: "70%" }}>
                                <TextField
                                  // required
                                  id="outlined-required"
                                  label="名前"
                                  variant="outlined"
                                  className="InsText2"
                                  multiline={true}
                                  InputProps={{ style: { borderColor: "red" } }}
                                  {...register(`bleach[${index}].name`)}
                                  error={"`bleach[${index}].name`" in errors}
                                  helperText={
                                    bleachErrors &&
                                    bleachErrors[index]?.name?.message
                                  }
                                />

                                <TextField
                                  // required
                                  id="outlined-required"
                                  label="メールアドレス"
                                  variant="outlined"
                                  className="InsText3"
                                  multiline={true}
                                  {...register(`bleach[${index}].user_name`)}
                                  error={
                                    "`bleach[${index}].user_name`" in errors
                                  }
                                  helperText={
                                    bleachErrors &&
                                    bleachErrors[index]?.user_name?.message
                                  }
                                />
                                <ServerlessDeleteButton
                                  onClick={() => remove(index)}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </section>
                  </div>
                </td>
                <td className="tg-0lax" rowSpan={length}>
                  <Button
                    style={{ color: "#fff", backgroundColor: "#FFA500" }}
                    variant="contained"
                    size="large"
                  >
                    資料アップロード
                    <input
                      type="file"
                      style={{ height: "39px" }}
                      multiple
                      name="file"
                      onChange={onChangeFile}
                      className="inputFileBtnHide"
                    />
                  </Button>
                  <Box
                    sx={{
                      p: 2,
                      height: 200,
                      border: "1px dashed grey",
                      overflow: "auto",
                    }}
                  >
                    {files.map((file: File, index: number) => (
                      <div key={index}>
                        {file.name}
                        {"　"}
                        <ServerlessDeleteButton
                          onClick={onClickDelFile(index)}
                        />
                      </div>
                    ))}
                  </Box>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    id="outlined-basic"
                    label="備考"
                    variant="outlined"
                    className="InsText"
                    multiline={true}
                    rows={2}
                    {...register("set_ins_memo")}
                    error={"set_ins_memo" in errors}
                    helperText={errors.set_ins_memo?.message}
                    onChange={change_ins_memo}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        <Stack spacing={3} margin={2}></Stack>
        <Stack spacing={0} margin={0}>
          <Grid container spacing={0}>
            <Grid item xs={2} className="btnIn">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    // disabled={loading}
                    size="large"
                    type="submit"
                  >
                    作成
                  </Button>
                  {/* ローディングがtrueの時の挙動 */}
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    className="btnlink"
                    color="primary"
                    variant="contained"
                    size="large"
                    component={Link}
                    to={{
                      pathname: "/Inspectionlist",
                      state: { conid: conid },
                    }}
                  >
                    キャンセル
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </form>
    </GenericTemplate>
  );
};
export default InspectionCreat;
